module.exports = __webpack_public_path__ + "static/img/2649d102.svg";